import React from 'react';

function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-logo">
          <h1>DUSTYTRAIN.IO</h1>
          <p>OPEN INFRASTRUCTURE INTELLIGENCE ENGINE</p>
        </div>
        
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring delay-1"></div>
          <div className="spinner-ring delay-2"></div>
        </div>
        
        <div className="loading-text">
          <p>Initializing knowledge graph...</p>
          <p className="loading-subtext">Mapping civilization</p>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;